import { useTranslate } from "@similarweb/i18n-provider";
import { HangtimeBlue } from "@similarweb/icons/illustrations";
import { Button, PromoBanner } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { RankTrackerBannerWrapper } from "app/pages/digital-marketing/keywords-campaigns/shared/components/styles";

import { POSITION_ANNOUNCEMENT_READ_MORE_URL } from "./constants";

export const PositionAnnouncementBanner = () => {
    const { translate } = useTranslate();

    const handleReadMore = () => {
        window.open(POSITION_ANNOUNCEMENT_READ_MORE_URL, "_blank", "noopener,noreferrer");
    };

    return (
        <RankTrackerBannerWrapper data-automation="rank-tracker-position-announcement-banner">
            <PromoBanner>
                <HangtimeBlue size={80} />
                <PromoBanner.Content>
                    <PromoBanner.Title>
                        {translate("rankTracker.shared.positionAnnouncementBanner.title")}
                    </PromoBanner.Title>
                    <PromoBanner.Description>
                        {translate("rankTracker.shared.positionAnnouncementBanner.body")}
                    </PromoBanner.Description>
                </PromoBanner.Content>
                <Flex flexShrink={0}>
                    <Button
                        type="primary"
                        onClick={handleReadMore}
                        data-automation="rank-tracker-position-announcement-read-more"
                    >
                        {translate("rankTracker.shared.positionAnnouncementBanner.readMore")}
                    </Button>
                </Flex>
            </PromoBanner>
        </RankTrackerBannerWrapper>
    );
};
